/**
 *
 * @param location
 * @param prefixes
 * @return {boolean}
 */
export function checkPrefix(location, ...prefixes) {
  return prefixes.some(
    prefix => (location.pathname.split('/')[1] === prefix)
  )
}

/**
 *
 * @param id id del div da creare che poi viene inserito nel body
 */
export function createDivElement(id) {
  const divElement = document.createElement("div");
  if(!!id) {
    divElement.setAttribute("id", id);
  }
  return divElement;
}

export function insertAsFirstBodyChild(divElement) {
  const firstChild =  document.body.firstChild;
  document.body.insertBefore(divElement, firstChild);
}

export function insertBeforeFooter(divElement) {
  const footer = document.getElementById('hrs-footer');
  document.body.insertBefore(divElement, footer);
}

export function deleteByID (id) {
  const elem = document.getElementById(id);
  if(!!elem) {
    elem.remove();
  }
}

export function createFooter(sidebar) {
  sidebar = sidebar || false;
  const footerID = 'footer-container';
  const footerClass = sidebar ? 'withSidebar' : 'withoutSidebar';
  deleteByID(footerID);
  const footerContainer = createDivElement(footerID);
  const linkList = createDivElement();
  const line = createDivElement();

  linkList.classList.add('link-list');
  line.classList.add('line');
  const terminiLink = `
      CINECA Consorzio Interuniversitario &copy;${new Date().getFullYear()}
      <a href="#" target="_blank" onclick="return false;">Termini</a>
      <a href="#" target="_blank" onclick="return false;">Privacy</a>
      <a href="#" onclick="window.cookieConsent.showSettings(); return false; ">Gestisci cookie</a>
  `;
  linkList.appendChild(line);
  linkList.innerHTML = terminiLink;
  footerContainer.classList.add(footerClass);
  footerContainer.appendChild(linkList);
  const sideNavContent = document.querySelectorAll('[id^="single-spa-application:@muapp"]');
  if(!!sideNavContent.length) {
    sideNavContent[0].appendChild(footerContainer);
  }
}

/**
 *
 * @param name nome del div da creare
 * @param divName nome del div dove iserire il div creato
 */
export function addDivElementToDiv(name, divName) {
  const divElement = document.createElement("div");
  divElement.setAttribute("id", name);
  const firstChild =  document.body.firstChild;
  document.body.insertBefore(divElement, firstChild);
}

/**
 *
 * @param name
 */
export function removeDivElement(name) {
  let elm = document.getElementById(name);
  if (elm) elm.remove();
}



/**
 *
 * @param singlespa singlespa instance
 * @param appName the name of the application
 * @param appUrl import-map property name
 * @param activityFn function to be called when path change
 * @param customProps customProps
 */
export function loadApplication(singlespa, appName, appUrl, activityFn, customProps) {
  return singlespa.registerApplication(
    appName,
    () => System.import(appUrl),
    activityFn,
    customProps
  );
}
